import { generateBannerDateApiUrl } from "@modules/util/url"

let currentPage = 1

export type EventHighlightListResponse = {
    messageId: string
    message: string
    entries: string[]
    hasMoreEntries: boolean
}

export const loadInitialEventHighlightCards = async (): Promise<EventHighlightListResponse> => {
    const response = await fetch(generateBannerDateApiUrl("/api/event-highlight/list/html"), {
        method: "GET",
    } as RequestInit)

    return await response.json()
}

export const loadMoreEventHighlightCards = async (): Promise<EventHighlightListResponse> => {
    const nextPage: number = ++currentPage

    const response = await fetch(generateBannerDateApiUrl(`/api/event-highlight/list/html?page=${nextPage}`), {
        method: "GET",
    } as RequestInit)

    return await response.json()
}
